import styled, { css, keyframes } from 'styled-components';
import arrowBackSvg from './arrow-back.inline.svg';
import CrossSvg from './cross.inline.svg';
import { media } from '../../ui';
const openAnimation = keyframes(["from{opacity:0;}to{opacity:1;}"]);
const openContentAnimation = keyframes(["from{transform:scale(.75);}to{transform:scale(1);}"]);
const closeAnimation = keyframes(["from{margin:0;visibility:visible;opacity:1;}99%{margin:0}to{margin:-9999px 0 0 -9999px;visibility:hidden;opacity:0;}"]);
const closeContentAnimation = keyframes(["from{transform:scale(1);}to{transform:scale(1.5);}"]);
export const HeaderArrowBack = styled(arrowBackSvg).withConfig({
  displayName: "Style__HeaderArrowBack",
  componentId: "sc-d8v3q6-0"
})(["position:absolute;"]);
export const HeaderImage = styled.div.withConfig({
  displayName: "Style__HeaderImage",
  componentId: "sc-d8v3q6-1"
})(["img{width:", ";}"], ({
  theme
}) => theme.logo.size);
export const HeaderSubtitle = styled.div.withConfig({
  displayName: "Style__HeaderSubtitle",
  componentId: "sc-d8v3q6-2"
})(["font-size:", "px;color:", ";"], ({
  theme: {
    fontSize
  }
}) => fontSize.sm, ({
  theme: {
    color
  }
}) => color.grayText);
export const HeaderTitle = styled.div.withConfig({
  displayName: "Style__HeaderTitle",
  componentId: "sc-d8v3q6-3"
})(["margin-right:40px;font-size:", "px;font-weight:500;color:#000;", ";"], ({
  theme: {
    fontSize
  }
}) => fontSize.lg, ({
  hasBackArrow
}) => hasBackArrow && css(["margin-left:25px;"]));
export const Close = styled.div.withConfig({
  displayName: "Style__Close",
  componentId: "sc-d8v3q6-4"
})(["position:absolute;top:2px;right:2px;display:flex;align-items:center;justify-content:center;width:48px;height:48px;cursor:pointer;", ""], media.sm`
    top: 0;
    right: 0;
    margin-top: 6px;
  `);
export const CrossImg = styled(CrossSvg).withConfig({
  displayName: "Style__CrossImg",
  componentId: "sc-d8v3q6-5"
})(["path{fill:", ";}"], ({
  theme: {
    color
  }
}) => color.primary);
export const Body = styled.div.withConfig({
  displayName: "Style__Body",
  componentId: "sc-d8v3q6-6"
})(["position:relative;padding-top:16px;p:last-child{margin:0;}", " ", ""], media.sm`
    padding: 48px 12px 0;
    margin: auto;
  `, media.xs`
    padding-top: 8px;
  `);
export const Header = styled.div.withConfig({
  displayName: "Style__Header",
  componentId: "sc-d8v3q6-7"
})(["display:flex;flex-flow:column;justify-content:center;font-size:", "px;", " ", ""], ({
  theme: {
    fontSize
  }
}) => fontSize.h6, ({
  hasBottomBorder
}) => hasBottomBorder && css(["border-bottom:1px solid ", ";"], ({
  theme: {
    color
  }
}) => color.middleGray), media.sm`
    z-index: 1;
    width: 100%;
    padding: 19px 12px;
    background: #fff;
    
    ${({
  hasSubtitle
}) => hasSubtitle && css(["padding:11px 12px;"])}
  `);
export const Content = styled.div.withConfig({
  displayName: "Style__Content",
  componentId: "sc-d8v3q6-8"
})(["position:relative;padding:32px;background-color:", ";background-clip:padding-box;border:1px solid #a7a7a7;border-radius:12px;", ""], ({
  theme: {
    color
  }
}) => color.white, media.sm`
    width: 100%;
    min-height: 100%;
    padding: 0;
    border-radius: 0;
  `);
export const Dialog = styled.div.withConfig({
  displayName: "Style__Dialog",
  componentId: "sc-d8v3q6-9"
})(["position:relative;width:100%;max-width:760px;max-height:100%;margin:auto;animation:", " .2s ease-in-out;", " ", ""], closeContentAnimation, ({
  isSmall
}) => isSmall && css(["max-width:520px;"]), media.sm`
    height: 100%;
    max-width: inherit;
    margin: 0;
    border-radius: 0;
    animation: none !important;
  `);
export const Root = styled.div.withConfig({
  displayName: "Style__Root",
  componentId: "sc-d8v3q6-10"
})(["position:fixed;top:0;right:0;bottom:0;left:0;z-index:1090;display:flex;flex-direction:column;justify-content:center;padding:100px 0;margin:-9999px 0 0 -9999px;overflow:auto;visibility:hidden;background:rgba(27,27,27,.75);", " ", " ", ";", ""], ({
  isShown
}) => isShown && css(["animation:", " .2s ease-in-out;"], closeAnimation), ({
  isOpen
}) => isOpen && css(["margin:0;animation:", " .2s ease-in-out;visibility:visible;", "{animation:", " .2s ease-in-out;}"], openAnimation, Dialog, openContentAnimation), ({
  isLoading
}) => isLoading && css(["", "{padding:20px;", "}"], Content, media.sm`
        padding-top: 108px;
      `), media.sm`
    padding: 0;
    animation: none;
  `);